import React, { useContext, useState, useEffect, useRef } from "react";
import Head from "next/head";
import Router, { withRouter } from "next/router";
import ReactPaginate from "react-paginate";

import { getGamesForCategory } from "../../../utils/api";
import { Context } from "../../../context";
import { pageStyle, mediumFont } from "../../../utils/styles";
import { CategoryIcon } from "../../../utils/icons";
import Layout from "../../../components/Layout";
import BannerAd from "../../../components/BannerAd";
import ItemsGrid from "../../../components/ItemsGrid";
import Pagination from "../../../components/Pagination";
import GoogleAd from "../../../components/GoogleAd";
import Page404 from "../../404";

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop - 15);

const GameCategory = ({ games, slug, router, currentPage, pageCount }) => {
  const [isLoading, setLoading] = useState(false);
  const startLoading = () => setLoading(true);
  const stopLoading = () => setLoading(false);
  const contentRef = useRef(null);
  const { menu } = useContext(Context);

  const category = menu.categories.find((c) => c.slug === slug);
  if (!category) {
    return <Page404 />
  }

  useEffect(() => {
    Router.events.on("routeChangeStart", startLoading);
    Router.events.on("routeChangeComplete", stopLoading);

    return () => {
      Router.events.off("routeChangeStart", startLoading);
      Router.events.off("routeChangeComplete", stopLoading);
    }
  }, []);

  useEffect(() => {
    if (!isLoading && games.length > 0) {
      const lazyItems = [].slice.call(document.querySelectorAll(".games img"));
      function loadItems(e) {
        setTimeout(function () {
          if (lazyItems.length) {
            lazyItems.forEach(function (lazyItem) {
              lazyItem.setAttribute("src", lazyItem.getAttribute("data-src"));
            });
          }
        }, 500);
        window.removeEventListener("scroll", loadItems);
      }
      window.addEventListener("scroll", loadItems);

      if (contentRef.current) {
        scrollToRef(contentRef);
      }
    }
  }, [games, isLoading]);

  const paginationHandler = (newPage) => {
    if (currentPage !==  newPage.selected + 1) {
      const currentPath = router.pathname;
      const currentQuery = router.query;
      currentQuery.page = newPage.selected + 1;

      router.push({
        pathname: currentPath,
        query: currentQuery,
      });
    }
  };

  return (
    <Layout>
      <Head>
        <title>{`${category.name} Games  - AppCheeta`}</title>

        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.pg = window.pg || {};
              pg.disabledUnits = pg.disabledUnits || [];
              pg.disabledUnits.push('/23081961,22672082578/appcheeta_desk_leaderboard_lazy', '/23081961,22672082578/appcheeta_desk_sidebar1', '/23081961,22672082578/appcheeta_desk_sidebar2', '/23081961,22672082578/appcheeta_mob_leaderboard', '/23081961,22672082578/appcheeta_mob_leaderboard_lazy');
            `,
          }}
        />
      </Head>
      <div className="page-content">
        <style jsx>{pageStyle}</style>
        <style jsx>{`
          .section {
            margin-top: 2rem;
            margin-bottom: 2.5rem;
          }
          .section-content {
            margin-bottom: 2rem;
          }
          .subtitle {
            font-size: ${mediumFont};
            font-weight: bold;
            margin-bottom: 1.5rem;
          }
        `}</style>
        <BannerAd />
        <div className="section games" ref={contentRef}>
          <h2 className="subtitle">
            <CategoryIcon />&nbsp;&nbsp;{category.name}
          </h2>
          <div className="section-content">
            <ItemsGrid items={games} path="game" categorized={false} width={70} />
          </div>

          {pageCount > 1 && (
            <Pagination
              currentPage={currentPage}
              pageCount={pageCount}
              paginationHandler={paginationHandler}
            />
          )}
        </div>

        <GoogleAd section="leaderboard" />
      </div>
    </Layout>
  );
};

GameCategory.getInitialProps = async ({ query, cached }) => {
  const { slug, page = 1 } = query;
  const {
    games,
    pages: pageCount,
    page: currentPage,
  } = await getGamesForCategory({ slug, page, cached });
  const analytics = {
    content_group1: "Category", // Page Type
  };
  return { games, pageCount, currentPage, slug, analytics };
};

export default withRouter(GameCategory);
